// extracted by mini-css-extract-plugin
export default {"inputRow":"reports_inputRow__+ycVA","width100":"reports_width100__1oFyZ"};